module.exports = __webpack_public_path__ + "static/media/home-run.f811619a.svg";